// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ReactGA from "react-ga4";
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';
import InstalersList from '../../../components/Advisory/InstalersList'

var generalCommonJS = require("../../../js/generalCommon.js")
var advisoryCommonJS = require("../../../js/advisoryCommon.js")
var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

// Advisory - Energy Billing
const BatteriesInstallation = () => {
  
  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Baterías"     
    document.querySelector('meta[name="description"]').setAttribute("content", "¿Quieres que te ayude a ver si te interesa instalar baterías?");

    if(initialConfigCommonJS.existeSesion()){
      var dashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
      var numeroDiasConDatos = 0
      var timestampAhora = parseInt(Date.now() / 1000)
      var timestampDesdeRegistro = parseInt(dashboardData.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)

      numeroDiasConDatos = (timestampAhora - timestampDesdeRegistro) / 86400
      
      if(numeroDiasConDatos >= 20){
        if( document.getElementById("divTablaResultados").className.includes("hidden") && document.getElementById("localizadorInstaladores").className.includes("hidden")){
          comprobarNecesidadBaterias()
        }
      }
      else{
        document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "")      
        
        if((30 - numeroDiasConDatos) === 1 ){
          document.getElementById("textoNecesitoMasDatos").innerHTML = "Necesito monitorizar más tiempo tu instalación para poder darte una recomendación. <strong>Podré decirte algo dentro de " + parseInt(30 - numeroDiasConDatos) + " día</strong>."
        }
        else{
          document.getElementById("textoNecesitoMasDatos").innerHTML = "Necesito monitorizar más tiempo tu instalación para poder darte una recomendación. <strong>Podré decirte algo dentro de " + parseInt(30 - numeroDiasConDatos) + " días</strong>."
        }   
      }
    }
    else{ // Estoy consultando desde el área pública
      // Meter campos adicionales en el formulario y modificar lambda de asesoramiento para que los tome como parámetros.

      document.getElementById("formularioDatosPublicos").className = document.getElementById("formularioDatosPublicos").className.replaceAll(" hidden", "")
      document.getElementById("resultadosAnalisis").className = document.getElementById("resultadosAnalisis").className.replaceAll(" hidden", "") + " hidden"          

      //Inicializo formulario
      console.log("Inicializo formulario")
      
      document.getElementById("selectBateriasGrupoElectrogeno").value = "false"      
      document.getElementById("selectBateriasTienePaneles").value = "false"
      document.getElementById("selectBateriasConectadaRed").value = "true"
      document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className = document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("mensajeFacturaBaterias").className = document.getElementById("mensajeFacturaBaterias").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("bloqueExcedente").className = document.getElementById("bloqueExcedente").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("labelConsumoPunta").innerHTML = "Consumo punta"
      document.getElementById("fieldsetConsumoLlano").className = document.getElementById("fieldsetConsumoLlano").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetConsumoValle").className = document.getElementById("fieldsetConsumoValle").className.replaceAll(" hidden", "")

      document.getElementById("consumoPunta").value = ""
      document.getElementById("consumoLlano").value = ""
      document.getElementById("consumoValle").value = ""
      document.getElementById("potenciaFVInstalada").value = ""
      document.getElementById("excedenteVendido").value = ""

    }

    console.log("Abro asesoramiento para la instalación de baterías.")

  });

  const [objListadoInstaladores, setObjListadoInstaladores] = useState([]) 
  var costeMedioKwh = 0

  function validacionCamposCorrecta(){
    
    var numeroErroresValidacion = 0

    document.getElementById("consumoPunta").className = document.getElementById("consumoPunta").className.replaceAll("error","")
    document.getElementById("consumoLlano").className = document.getElementById("consumoLlano").className.replaceAll("error","")
    document.getElementById("consumoValle").className = document.getElementById("consumoValle").className.replaceAll("error","")
    document.getElementById("potenciaFVInstalada").className = document.getElementById("potenciaFVInstalada").className.replaceAll("error","")
    document.getElementById("excedenteVendido").className = document.getElementById("excedenteVendido").className.replaceAll("error","")

    if(!document.getElementById("bloqueConsumos").className.includes("hidden")){
      if(document.getElementById("consumoPunta").value === ""){
        document.getElementById("consumoPunta").className = "error"
        numeroErroresValidacion++    
      }

      if(!document.getElementById("fieldsetConsumoLlano").className.includes("hidden")){
        if(document.getElementById("consumoLlano").value === ""){
          document.getElementById("consumoLlano").className = "error"
          numeroErroresValidacion++    
        }
      }
      
      if(!document.getElementById("fieldsetConsumoValle").className.includes("hidden")){
        if(document.getElementById("consumoValle").value === ""){
          document.getElementById("consumoValle").className = "error"
          numeroErroresValidacion++    
        }
      }
    }

    if(!document.getElementById("bloqueExcedente").className.includes("hidden")){
      
      if(document.getElementById("potenciaFVInstalada").value === ""){
        document.getElementById("potenciaFVInstalada").className = "error"
        numeroErroresValidacion++    
      }
  
      
      if(!document.getElementById("fieldsetExcedenteVendido").className.includes("hidden")){
  
        if(document.getElementById("excedenteVendido").value === ""){
          document.getElementById("excedenteVendido").className = "error"
          numeroErroresValidacion++    
        }
      }
    }

    if(numeroErroresValidacion > 0){          
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos marcados en rojo antes de continuar.","negative")
      return false
    }
    else{      
      return true
    }
    
  }

  function comprobarNecesidadBateriasPublica(){

    if((document.getElementById("selectBateriasGrupoElectrogeno").value === "false") && (document.getElementById("selectBateriasTienePaneles").value === "false") && (document.getElementById("selectBateriasConectadaRed").value === "false")){

      document.getElementById("formularioDatosPublicos").className = document.getElementById("formularioDatosPublicos").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("resultadosAnalisis").className = document.getElementById("resultadosAnalisis").className.replaceAll(" hidden", "") 
      document.getElementById("detailDatosAnalisis").className = document.getElementById("detailDatosAnalisis").className.replaceAll(" hidden", "") 

      document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" sucess","").replaceAll(" error", "")
      document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")

      var conclusion = "Lo siento, pero no puedo ayudarte"
      var textoSugerencia = '<p>Sin paneles o alguna fuente alternativa de energía no tiene sentido la instalación de baterías.</p>'

      document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" warning","") + " warning"
      document.getElementById("iconoResultado").innerHTML = "thumbs_up_down"          
      try{
        document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
      }catch(error){}
      document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")        
      document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("detailDatosAnalisis").className = document.getElementById("detailDatosAnalisis").className.replaceAll(" hidden", "") + " hidden"                    
      
      document.getElementById("conclusion").innerHTML = conclusion
      document.getElementById("textoSugerencia").innerHTML = textoSugerencia          

      document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")

    }
    else{

      if(validacionCamposCorrecta()){
        var tsFechaHasta = parseInt(new Date().getTime()/1000)
        var tsFechaDesde = tsFechaHasta - 2592000 //Le resto los segundos que tiene 1 mes
  
        var fechaDesde = new Date(tsFechaDesde*1000).toISOString().split("T")[0]
        var fechaHasta = new Date(tsFechaHasta*1000).toISOString().split("T")[0]
        
        var url = "https://api.esios.ree.es/indicators/1001?start_date="+fechaDesde+"T00%3A00%3A00%2B02%3A00&end_date="+fechaHasta+"T23%3A55%3A00%2B02%3A00&time_agg=avg&geo_ids[]=8741&geo_agg=sum&time_trunc=month&locale=es"
  
        document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "")
        
  
        var xhttp = new XMLHttpRequest();
        xhttp.open("GET", url, true);    
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Accept', "application/json; application/vnd.esios-api-v1+json");
        xhttp.setRequestHeader('x-api-key', "cf946ba5de11ae589eae338a2fbad927a3300950daa80b683a8ab4ffe125f9ee");
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {          
              
              var jsonRespuestaPrecios = JSON.parse(this.responseText)
  
              costeMedioKwh = parseFloat(jsonRespuestaPrecios.indicator.values[jsonRespuestaPrecios["indicator"]["values"].length-1].value/1000).toFixed(3)
              comprobarNecesidadBaterias()
  
              document.getElementById("loaderDetalleAdvisory").className = document.getElementById("loaderDetalleAdvisory").className.replaceAll(" hidden", "") + " hidden"
              console.log("Precio medio PVPC último mes cargado correctamente.")  
  
              return costeMedioKwh
              
            }
            if (this.readyState === 4 && this.status !== 200) {                
              initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
            }            
        };
        xhttp.send();  
      } 

    }

  }

  function comprobarNecesidadBaterias(){

    document.getElementById("formularioDatosPublicos").className = document.getElementById("formularioDatosPublicos").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("resultadosAnalisis").className = document.getElementById("resultadosAnalisis").className.replaceAll(" hidden", "") 
    document.getElementById("detailDatosAnalisis").className = document.getElementById("detailDatosAnalisis").className.replaceAll(" hidden", "") 
    
    var dashboardData = {
      "FVData":{
        "FVMaxGeneration": {
          "Value": "",          
          "Unit": "kW"
        }
      },
      "GeneratorData":{},
      "InstallationData": {
        "GeneralInfo": {			
          "EnergyGridConnected": ""			
        }
      },
      "SelfConsumptionAndSavingsData": {
        "YearfromGridPerTimeframe": "",
        "YeartoGrid": {
          "Value": "",
          "Unit": "Wh"
        }
      }
    }

    var tienePaneles = "true"

    if(initialConfigCommonJS.existeSesion()){
      dashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
    }
    else{
      tienePaneles = document.getElementById("selectBateriasTienePaneles").value
      dashboardData.InstallationData.GeneralInfo.EnergyGridConnected = document.getElementById("selectBateriasConectadaRed").value
      dashboardData.SelfConsumptionAndSavingsData.YeartoGrid.Value = (parseFloat(document.getElementById("excedenteVendido").value)*1000).toString()
      dashboardData.SelfConsumptionAndSavingsData.YearfromGridPerTimeframe = parseFloat(document.getElementById("consumoPunta").value.replaceAll(",","."))*1000 + "#" + parseFloat(document.getElementById("consumoLlano").value.replaceAll(",","."))*1000 + "#" + parseFloat(document.getElementById("consumoValle").value.replaceAll(",","."))*1000
      
      if(document.getElementById("selectBateriasTienePaneles").value === "true"){
        dashboardData.FVData.FVMaxGeneration.Value = (parseFloat(document.getElementById("potenciaFVInstalada").value)*1000).toString()
      }
      else{
        dashboardData.FVData = {}
      }      
      
      if(document.getElementById("selectBateriasGrupoElectrogeno").value === "true"){
        dashboardData.GeneratorData.GeneratorExist = "true"
      }
      else{
        dashboardData.GeneratorData = {}
      }

    }

    document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0
    document.getElementById("divTablaResultados").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "")

    if(dashboardData.InstallationData.GeneralInfo.EnergyGridConnected === "true"){

      if(tienePaneles === "true"){

        // LO PRIMERO ES COMPROBAR SI VENDO MÁS QUE CONSUMO, PORQUE SI CONSUMO MÁS QUE VENDO NO SALEN A CUENTA CLARAMENTE...
        
        var excedenteVendidoAñoEnCurso = dashboardData.SelfConsumptionAndSavingsData.YeartoGrid.Value

        var consumoEstimadoNocturno = 0      
        var elementosConsumoTramos = dashboardData.SelfConsumptionAndSavingsData.YearfromGridPerTimeframe.split("#")
        var totalEnergiaComprada = 0

        for(var x=0; x<elementosConsumoTramos.length; x++){
          totalEnergiaComprada = totalEnergiaComprada + parseFloat(elementosConsumoTramos[x])
        }

        var porcentajeTramoNocturno = 0

        if(elementosConsumoTramos.length === 6){ //3.0        
          porcentajeTramoNocturno = parseFloat(elementosConsumoTramos[5]) / totalEnergiaComprada
        }
        else{ //2.0        
          porcentajeTramoNocturno = parseFloat(elementosConsumoTramos[2]) / totalEnergiaComprada
        }

        if(initialConfigCommonJS.existeSesion()){
          consumoEstimadoNocturno = parseFloat(dashboardData.SelfConsumptionAndSavingsData.YearfromGrid.Value)  * porcentajeTramoNocturno
        }
        else{
          consumoEstimadoNocturno = totalEnergiaComprada * porcentajeTramoNocturno
        }

        // Le sumo parte del horario nocturno llano proporcional 3 horas nocturnas valle / 24 horas día = 0.125
        consumoEstimadoNocturno = consumoEstimadoNocturno + (consumoEstimadoNocturno * 0.125)

        var numeroDiasConDatos = 0

        if(initialConfigCommonJS.existeSesion()){
        
          var timestampAhora = parseInt(Date.now() / 1000)
          var timestampInicioAñoEnCurso = new Date( new Date().getFullYear(), 0, 1).getTime()/ 1000;
          var timestampDesdeRegistro = parseInt(dashboardData.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)

          if(timestampDesdeRegistro > timestampInicioAñoEnCurso){ //Se ha registrado ya empezado el año
            numeroDiasConDatos = (timestampAhora - timestampDesdeRegistro) / 86400
          }
          else{ //Se registró el año pasado
            numeroDiasConDatos = (timestampAhora - timestampInicioAñoEnCurso) / 86400
          }
        }
        else{
          numeroDiasConDatos = 30
        }

        consumoEstimadoNocturno = consumoEstimadoNocturno / numeroDiasConDatos
        var excedenteMedioDiario = excedenteVendidoAñoEnCurso / numeroDiasConDatos

        if(excedenteMedioDiario >= consumoEstimadoNocturno){

          //Actualizo los trámites
          document.getElementById("listadoTramites").innerHTML = ""

          var aplicaSubvencion = false
          var importeSubvencion = 0

          if( parseInt(consumoEstimadoNocturno) <= 15000){

            if ( ( 0 < parseInt(consumoEstimadoNocturno)) && ( parseInt(consumoEstimadoNocturno) <= 5500) ){
              importeSubvencion = 5 * 490
            }
            else if ( ( 5500 < parseInt(consumoEstimadoNocturno)) && ( parseInt(consumoEstimadoNocturno) <= 10500) ){        
              importeSubvencion = 10 * 490
            }
            else if ( ( 10000 < parseInt(consumoEstimadoNocturno)) && ( parseInt(consumoEstimadoNocturno) <= 15000) ){  
              importeSubvencion = 15 * 350
            }

            document.getElementById("listadoTramites").innerHTML += '<li class="success">Te correspondería <strong>subvención de '+new Intl.NumberFormat('en-DE').format(importeSubvencion)+' €, por tanto habría que solicitarla</strong>. Esto lo gestiona el instalador, pero sino te lo puede hacer una gestoría.</li>'
            document.getElementById("listadoTramites").innerHTML += '<ul class="default-list"><li>¡Ojo! porque las subvenciones son limitadas, podrían acabarse o rechazártela por algún motivo.</li></ul>'
            aplicaSubvencion = true
          }
          else{
            document.getElementById("listadoTramites").innerHTML += '<li class="success">Ninguno ya que no te correspondería <strong>subvención (hasta el 65% del coste), únicamente se conceden para instalaciones con un almacenaje de 10kWh o inferior.</li>'        
            aplicaSubvencion = false
          }
          
          var numeroBaterias = parseInt(consumoEstimadoNocturno/5000)+1
          var numeroInversores = parseInt(consumoEstimadoNocturno/15000)+1
          var numeroBackups = numeroInversores

          document.getElementById("numeroBaterias").innerHTML = numeroBaterias
          document.getElementById("numeroInversores").innerHTML = numeroInversores
          document.getElementById("numeroBackups").innerHTML = numeroBackups

          document.getElementById("capacidadAlmacenaje").innerHTML = numeroBaterias*5 + " kW"
          
          consumoEstimadoNocturno = consumoEstimadoNocturno/1000

          var costeMediokWh = 0

          if(initialConfigCommonJS.existeSesion()){
            var consumoMesActual = parseFloat(dashboardData.SelfConsumptionAndSavingsData.CurrentMonthfromGrid.Value)/1000
            var gastoMesActual = parseFloat(dashboardData.SelfConsumptionAndSavingsData.CurrentMonthenergyWaste.Value)
                  
            costeMediokWh = parseFloat(gastoMesActual / consumoMesActual).toFixed(3)
          }
          else{
            costeMediokWh = costeMedioKwh

            console.log(costeMediokWh)
          }

          var costeEstimadoNocturno = consumoEstimadoNocturno * costeMediokWh
          
          var costeNocturnoAnual = costeEstimadoNocturno * 365

          document.getElementById("consumoDiario").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(consumoEstimadoNocturno).toFixed(1)) + " kW"
          document.getElementById("costeDiario").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(costeEstimadoNocturno).toFixed(2)) + " €"
          document.getElementById("consumoMensual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(consumoEstimadoNocturno*30).toFixed(1)) + " kW"
          document.getElementById("costeMensual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(costeEstimadoNocturno*30).toFixed(2)) + " €"
          document.getElementById("consumoAnual").innerHTML =new Intl.NumberFormat('en-DE').format(parseFloat(consumoEstimadoNocturno*365).toFixed(1)) + " kW"
          document.getElementById("costeAnual").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(costeNocturnoAnual).toFixed(2)) + " €"

          //Calculo el PRESUPUESTO - PRECIOS SIN IVA (Se incluye al final)
          var presupuesto = 0

          //Incluyo las el inversor
          //Referencia: Módulo de control Huawei LUNA
          presupuesto = presupuesto + (numeroInversores * 1012)

          //Incluyo las baterías
          //Referencia: Módulo LUNA2000-5-E0 De 5kWh Para Ampliación De Batería De Litio Huawei
          presupuesto = presupuesto + (numeroBaterias * 2313)

          //Incluyo el backup
          //Referencia: Huawei Backup BOX-B0 Luna 2000 Monofásico
          presupuesto = presupuesto + (numeroBackups * 502)

          //Incluyo materiales + mano de obra
          presupuesto = presupuesto + 972

          //Incluyo el IVA
          presupuesto = presupuesto * 1.21
          
          var textoPresupuestoFinal = ""
          var presupuestoFinal = 0

          //Aplico subvención
          if(aplicaSubvencion){
            presupuestoFinal = presupuesto - importeSubvencion
            textoPresupuestoFinal = new Intl.NumberFormat('en-DE').format(presupuestoFinal) + ' € <p class="size-s">'+new Intl.NumberFormat('en-DE').format(presupuesto) + " € - "+new Intl.NumberFormat('en-DE').format(importeSubvencion)+" € (Sub)</p>"
          }
          else{
            presupuestoFinal = presupuesto
            textoPresupuestoFinal = new Intl.NumberFormat('en-DE').format(presupuestoFinal) + " €"
          }
                
          document.getElementById("presupuesto").innerHTML = textoPresupuestoFinal

          //Calculo AMORTIZACIÓN      
          var amortizacion = presupuestoFinal / costeNocturnoAnual 
          document.getElementById("amortizacion").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(amortizacion).toFixed(2)) + " Años"

          // Vida util de baterías
          var vidaUtilBaterias = 15      

          // AHORRO 
          var ahorro = (consumoEstimadoNocturno*365*vidaUtilBaterias*costeMediokWh) - presupuestoFinal

          if(ahorro < 0){
            ahorro = 0
          }

          document.getElementById("ahorro").innerHTML = new Intl.NumberFormat('en-DE').format(parseFloat(ahorro/vidaUtilBaterias).toFixed(2)) + " €"

          // CONCLUSIÓN
          var conclusion = ""
          var textoSugerencia = ""
          
          document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" sucess","").replaceAll(" error", "").replaceAll(" warning", "")
          document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")

          console.log(ahorro)
          console.log(vidaUtilBaterias)
          console.log(amortizacion)

          if(amortizacion < vidaUtilBaterias){
            if(ahorro > 0){ 
              conclusion = "Sí, te interesa instalar baterías."
              textoSugerencia = "Con una inversión de <strong>"+new Intl.NumberFormat('en-DE').format(presupuestoFinal)+" € </strong> "
              
              if(aplicaSubvencion){
                textoSugerencia = textoSugerencia + "(te aplica subvención) "
              }
              else{
                textoSugerencia = textoSugerencia + "(no te aplica subvención) "
              }
              
              textoSugerencia = textoSugerencia + "las amortizarías en <strong>"+new Intl.NumberFormat('en-DE').format(parseFloat(amortizacion).toFixed(2))+" años</strong> y además habrías ahorrado <strong>"+new Intl.NumberFormat('en-DE').format(parseFloat(ahorro/vidaUtilBaterias).toFixed(2))+" €</strong> al final de su vida útil."

              document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" success","") + " success"
              document.getElementById("iconoResultado").innerHTML = "thumb_up"          
              try{
                document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "")
              }catch(error){}
              document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")

              document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "")
              document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "")

            }
            else{ 
              conclusion = "No te interesa instalar baterías."           
              textoSugerencia = "Aunque las amortizarías antes de finalizar su vida útil, no tendrías ningún ahorro."
              document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" error","") + " error"
              document.getElementById("iconoResultado").innerHTML = "thumb_down"          
              try{
                document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
              }catch(error){}
              document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")  

              document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
              document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
              
            }
          }
          else{ 
            conclusion = "No te interesa instalar baterías."
            textoSugerencia = "No las amortizarías antes de finalizar su vida útil."
            document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" error","") + " error"
            document.getElementById("iconoResultado").innerHTML = "thumb_down"     
            try{     
              document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
            }catch(error){}
            document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")        
            document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
            document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
          }   

          document.getElementById("conclusion").innerHTML = conclusion
          document.getElementById("textoSugerencia").innerHTML = textoSugerencia
          

          document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")
        }
        else{ // No le interesan baterías ya que no tendría para cargarlas

          document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" error","") + " error"
          document.getElementById("iconoResultado").innerHTML = "thumb_down" 
          try{         
            document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
          }catch(error){}
          document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "") + " hidden"     
  
          document.getElementById("conclusion").innerHTML = "No te interesa instalar baterías"
          document.getElementById("textoSugerencia").innerHTML = "<p><strong>No tienes suficiente excedente</strong> para amortizar la inversión ni para que funcionen a un nivel de carga mínimo.</p><p>&nbsp;</p><p>A día de hoy mi consejo es que te centres en <strong>reducir tu consumo, tener buena tarifa eléctrica y bajar tu potencia contratada a lo que realmente necesites</strong>. Para todo esto yo te ayudaré revisando constantemente tu instalación y te avisaré cuando vea que puedes mejorar alguno de estos puntos.</p>"
          document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
          document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
  
        }
        
      }      
      else{ // Sin paneles
          
        document.getElementById("formularioDatosPublicos").className = document.getElementById("formularioDatosPublicos").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("resultadosAnalisis").className = document.getElementById("resultadosAnalisis").className.replaceAll(" hidden", "") 
        document.getElementById("detailDatosAnalisis").className = document.getElementById("detailDatosAnalisis").className.replaceAll(" hidden", "") 

        document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" sucess","").replaceAll(" error", "")
        document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")

        conclusion = "Lo siento, pero no puedo ayudarte"
        textoSugerencia = '<p>Sin paneles o alguna fuente alternativa de energía no tiene sentido la instalación de baterías.</p>'
        textoSugerencia = textoSugerencia + '<p>&nbsp</p><p> Si aun así te interesa tener algún tipo de almacenamiento de energía (para cortes de luz por ejemplo) <strong>quizá te interese más comprar un SAI</strong> (Sistema de Alimentación Ininterrumpida). Son baterías más pequeñas que se cargan de la red eléctrica, se le pueden poner a aparatos específicos y te pueden dar una autonomía de varias horas en caso de falta de suministro. <strong><a href="https://www.amazon.es/s?k=sai+ordenadores&adgrpid=80505988247&gclid=CjwKCAjwv4SaBhBPEiwA9YzZvHk3MGtehxfV8BW7Rocus4RQLP2Jlx3Zov9MEW3xDliainhKVpu5bhoCfRAQAvD_BwE&hvadid=601256233192&hvdev=c&hvlocphy=1005421&hvnetw=g&hvqmt=b&hvrand=3667694647538667345&hvtargid=kwd-303864446639&hydadcr=13839_2285376&tag=hydes-21&ref=pd_sl_3jise67cbt_b" rel="noopener noreferrer" target="_blank" className="link inline-link">Aquí</a></strong> puedes ver algunos por si les quieres echar un vistazo para ver si cubren tus necesidades.</p>'


        document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" warning","") + " warning"
        document.getElementById("iconoResultado").innerHTML = "thumbs_up_down"          
        try{
          document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
        }catch(error){}
        document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "")        
        document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
        document.getElementById("detailDatosAnalisis").className = document.getElementById("detailDatosAnalisis").className.replaceAll(" hidden", "") + " hidden"                    
        
        document.getElementById("conclusion").innerHTML = conclusion
        document.getElementById("textoSugerencia").innerHTML = textoSugerencia          

        document.getElementById("textoNecesitoMasDatos").className = document.getElementById("textoNecesitoMasDatos").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")

      }

      generalCommonJS.registrarEventoAnalitica(ReactGA, 'ASESORAMIENTO', 'ASESORAMIENTO - Sim. Baterías', document.getElementById("cardResultados").className, "")
    
    }
    else{ //Instalación desconectada de la red

      document.getElementById("cardResultados").className = document.getElementById("cardResultados").className.replaceAll(" success","") + " success"
      document.getElementById("iconoResultado").innerHTML = "thumb_up"          
      try{
        document.getElementById("botonContactoInstalador").className = document.getElementById("botonContactoInstalador").className.replaceAll(" hidden", "") + " hidden"
      }catch(error){}
      document.getElementById("detalleElementosBaterias").className = document.getElementById("detalleElementosBaterias").className.replaceAll(" hidden", "") + " hidden"     

      var potenciaFVInstalada = 0
      
      try{
        potenciaFVInstalada = parseFloat(dashboardData.FVData.FVMaxGeneration.Value.replaceAll(".",""))
      }
      catch(error){
        potenciaFVInstalada = 3500
      }

      var generacionMaximaInvierno = new Intl.NumberFormat('en-DE').format(parseFloat(((potenciaFVInstalada/1000) / 2) * 8).toFixed(2))
      var capacidadBateriasPorConsumo = 0
      
      var consumoTotalDesdeRegistro = 0

      if(initialConfigCommonJS.existeSesion()){
        consumoTotalDesdeRegistro = parseFloat(dashboardData.SelfConsumptionAndSavingsData.SinceRegistrationconsumption.Value)      
        
        numeroDiasConDatos = 0
        timestampAhora = parseInt(Date.now() / 1000)      
        timestampDesdeRegistro = parseInt(dashboardData.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)                  
        numeroDiasConDatos = (timestampAhora - timestampDesdeRegistro) / 86400
      }
      else{
        consumoTotalDesdeRegistro = parseFloat(dashboardData.SelfConsumptionAndSavingsData.YearfromGridPerTimeframe.split("#")[0])
        //numeroDiasConDatos ya lo setee arriba a 30 para las consultas públicas.
      }

      capacidadBateriasPorConsumo = parseFloat( ((consumoTotalDesdeRegistro / numeroDiasConDatos)) / 1000 ).toFixed(2)

      var capacidadBaterias = 0
      if(capacidadBateriasPorConsumo >= generacionMaximaInvierno){
        capacidadBaterias = generacionMaximaInvierno
      }
      else{
        capacidadBaterias = capacidadBateriasPorConsumo * 2
      }

      var mensaje = "<p>Revisando tu instalación y tus consumos <strong>tu capacidad perfecta de baterías</strong> a instalar sería de <strong>"+capacidadBaterias+" kW</strong>.</p>"

      if(Object.keys(dashboardData.GeneratorData).length === 0){
        mensaje = mensaje + "<p>&nbsp;</p><p>Aun así <strong>te recomiendo que te hagas con un grupo electrógeno de al menos 5,5kW para emergencias</strong>, los puedes encontrar de buena calidad por menos de 500€.</p>"
      }
      
      document.getElementById("conclusion").innerHTML = "Sin duda necesitas instalar baterías"
      document.getElementById("textoSugerencia").innerHTML = mensaje
      
      document.getElementById("detailTramites").className = document.getElementById("detailTramites").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("detailComponentes").className = document.getElementById("detailComponentes").className.replaceAll(" hidden", "") + " hidden"            
    }

  }

  function volverAResultados(){
    document.getElementById("localizadorInstaladores").className = document.getElementById("localizadorInstaladores").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("divTablaResultados").className = document.getElementById("divTablaResultados").className.replaceAll(" hidden", "")
  }

  function mostrarOcultarRestoFormulario(){
    
    if(document.getElementById("selectBateriasConectadaRed").value === "true"){

      document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className = document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className.replaceAll(" hidden", "") + " hidden"
      
      document.getElementById("labelConsumoPunta").innerHTML = "Consumo punta"
      document.getElementById("fieldsetConsumoLlano").className = document.getElementById("fieldsetConsumoLlano").className.replaceAll(" hidden", "")
      document.getElementById("fieldsetConsumoValle").className = document.getElementById("fieldsetConsumoValle").className.replaceAll(" hidden", "")
      document.getElementById("mensajeFacturaBaterias").className = document.getElementById("mensajeFacturaBaterias").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetExcedenteVendido").className = document.getElementById("fieldsetExcedenteVendido").className.replaceAll(" hidden", "")        

      document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("bloqueExcedente").className = document.getElementById("bloqueExcedente").className.replaceAll(" hidden", "") + " hidden"

      if(document.getElementById("selectBateriasTienePaneles").value === "true"){            
        document.getElementById("mensajeFacturaBaterias").className = document.getElementById("mensajeFacturaBaterias").className.replaceAll(" hidden", "")
        document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "")
        document.getElementById("bloqueExcedente").className = document.getElementById("bloqueExcedente").className.replaceAll(" hidden", "")
      }

    }
    else{ // DESCONECTADO DE LA RED
      
      document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className = document.getElementById("fieldsetSelectBateriasGrupoElectrogeno").className.replaceAll(" hidden", "")
      document.getElementById("mensajeFacturaBaterias").className = document.getElementById("mensajeFacturaBaterias").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "")
      
      document.getElementById("labelConsumoPunta").innerHTML = "Consumo total mes"
      document.getElementById("fieldsetConsumoLlano").className = document.getElementById("fieldsetConsumoLlano").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("fieldsetConsumoValle").className = document.getElementById("fieldsetConsumoValle").className.replaceAll(" hidden", "") + " hidden"

      document.getElementById("fieldsetExcedenteVendido").className = document.getElementById("fieldsetExcedenteVendido").className.replaceAll(" hidden", "") + " hidden"

      if(document.getElementById("selectBateriasTienePaneles").value === "true"){     
        document.getElementById("bloqueExcedente").className = document.getElementById("bloqueExcedente").className.replaceAll(" hidden", "")        
      }
      else{
        document.getElementById("bloqueExcedente").className = document.getElementById("bloqueExcedente").className.replaceAll(" hidden", "") + " hidden"        
      }
      
      if( (document.getElementById("selectBateriasTienePaneles").value === "false") && (document.getElementById("selectBateriasGrupoElectrogeno").value === "false") ){
        document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "") + " hidden"
      }
      else{
        document.getElementById("bloqueConsumos").className = document.getElementById("bloqueConsumos").className.replaceAll(" hidden", "")
      }


    }
  }

  return (      
    <main className="no-background">

      <div id="formularioDatosPublicos" className=" hidden">

        <p>Las baterías permiten almacenar el excedente energético y ofrecen autonomía, por ejemplo frente a apagones de luz. Pero no siempre interesa instalarlas. Rellena los siguientes datos y te diré cuál es tu caso...</p>

        { !initialConfigCommonJS.existeSesion() ?
            <>
            <p>&nbsp;</p>
            <p>Y tranquil@ que los datos de este formulario <strong>ni se guardan ni se comparten</strong>...</p>
            <p>&nbsp;</p>
            </>
          :
            <></>
        }

        <fieldset>

          <fieldset className="two-columns">

            <fieldset className="dropdown">
              <label htmlFor="labelBateriasConectadaRed">¿Instalación conectada a la red general?</label>            
              <div className="icon-wrapper">
                <select id="selectBateriasConectadaRed" onChange={() => mostrarOcultarRestoFormulario()}>
                  <option value="true">Sí</option>
                  <option value="false">No</option>                                  
                </select>
              </div>
            </fieldset>

            <fieldset className="dropdown">
              <label htmlFor="labelBateriasTienePaneles">¿Tienes paneles solares?</label>            
              <div className="icon-wrapper">
                <select id="selectBateriasTienePaneles" onChange={() => mostrarOcultarRestoFormulario()}>
                  <option value="true">Sí</option>
                  <option value="false">No</option>                                  
                </select>
              </div>
            </fieldset>

            <fieldset id="fieldsetSelectBateriasGrupoElectrogeno" className="dropdown hidden">
              <label htmlFor="labelBateriasTienePaneles">¿Tienes grupo electrógeno?</label>
              <div className="icon-wrapper">
                <select id="selectBateriasGrupoElectrogeno" onChange={() => mostrarOcultarRestoFormulario()}>
                  <option value="true">Sí</option>
                  <option value="false">No</option>                                  
                </select>
              </div>
            </fieldset>

          </fieldset>

          <div id="mensajeFacturaBaterias" className="message info left" style={{ marginTop: "20px"}}>
            <h1 className="title"><span className="material-icon">info</span>Datos de tu última factura</h1>
            <p className="size-s">Necesitas una factura para rellenar la siguiente información, te recomendamos usar cualquiera que NO sea de los siguientes meses: diciembre, enero, julio o agosto.</p>                              
          </div>

          <fieldset id="bloqueConsumos" className="two-columns">

            <fieldset>
              <label id="labelConsumoPunta" htmlFor="consumoPunta">Consumo punta</label>            
              <fieldset className="icon-wrapper data" data-label="kWh">            
                <input type="text" inputMode="decimal" id="consumoPunta" />
              </fieldset>
            </fieldset>

            <fieldset id="fieldsetConsumoLlano">
              <label htmlFor="consumoLlano">Consumo llano</label>            
              <fieldset className="icon-wrapper data" data-label="kWh">            
                <input type="text" inputMode="decimal" id="consumoLlano" />
              </fieldset>
            </fieldset>

            <fieldset id="fieldsetConsumoValle">
              <label htmlFor="consumoValle">Consumo valle</label>            
              <fieldset className="icon-wrapper data" data-label="kWh">            
                <input type="text" inputMode="decimal" id="consumoValle" />
              </fieldset>
            </fieldset>
          </fieldset>

          <fieldset id="bloqueExcedente" className="two-columns">
            
            <fieldset>
              <label htmlFor="potenciaFVInstalada">¿kW de paneles instalados?</label>            
              <fieldset className="icon-wrapper data" data-label="kW">            
                <input type="text" inputMode="decimal" id="potenciaFVInstalada" />
              </fieldset>
            </fieldset>

            <fieldset id="fieldsetExcedenteVendido">
              <label htmlFor="excedenteVendido">Excedente vendido</label>            
              <fieldset className="icon-wrapper data" data-label="kW">            
                <input type="text" inputMode="decimal" id="excedenteVendido" />
              </fieldset>
            </fieldset>


          </fieldset>

          <fieldset className="actions">            
            <button className="button primary full-width" onClick={() => comprobarNecesidadBateriasPublica()}>Dime si me interesa instalar baterías</button>         
          </fieldset>

        </fieldset>

      </div>

      <div id="resultadosAnalisis">
        <section id="welcome-01" className="step">

          <p id="textoNecesitoMasDatos"></p>               
          
          <div id="divTablaResultados" className="content-wrapper hidden">
            
            <div id="cardResultados" className="message medium left">
              <div className="horizontal">
                <span id="iconoResultado" className="material-icon">thumb_up</span>
                <h1 className="title" id="conclusion"> </h1>
              </div>
              
              <p id="textoSugerencia" style={{paddingTop: "15px"}}></p>
              
            </div>          

            <div id="detalleElementosBaterias" className="accordion-wrapper" style={{paddingTop: "20px"}}>

              <details id="detailTramites" className="accordion">
                <summary className="title">                
                  <span className="size-l">¿Qué trámites tengo que hacer?</span>
                </summary>
                <ul id="listadoTramites" className="default-list"/>                             
              </details>

              <details id="detailComponentes" className="accordion green">
                  <summary className="title">                  
                  <span className="size-l">Componentes de la instalación</span>
                  </summary>
                  <ul className="accordion-content columns col-sm-2 gap-04">
                    <li className="horizontal gap-03 center">
                      <figure className="avatar size-l"><span className="material-icon">grid_view</span></figure>
                      <dl className="vertical fill">
                        <dt className="size-m">Número de baterías</dt>
                        <dd id="numeroBaterias" className="size-l"></dd>
                      </dl>
                    </li>
                    <li className="horizontal gap-03 center">
                      <figure className="avatar size-l"><span className="material-icon">monitor_heart</span></figure>
                      <dl className="vertical fill">
                        <dt className="size-m">Inversores cargadores</dt>
                        <dd id="numeroInversores" className="size-l"></dd>
                      </dl>
                    </li>
                    <li className="horizontal gap-03 center">
                      <figure className="avatar size-l"><span className="material-icon">monitor_heart</span></figure>
                      <dl className="vertical fill">
                        <dt className="size-m">Back-up</dt>
                        <dd id="numeroBackups" className="size-l"></dd>
                      </dl>
                    </li>

                  </ul>
              </details>

              <details id="detailDatosAnalisis" className="accordion">
                  
                  <summary className="title">                
                    <span className="size-l">Datos análisis</span>       
                  </summary>              

                  <table id="tablaValoresEstimacion" className="min">
                    <thead>
                      <tr className="table-row">
                        <th className="table-cell label"></th>
                        <th className="table-cell max">Consumo medio</th>
                        <th className="table-cell min">Coste</th>
                      </tr>
                    </thead>
                    <tbody>

                      <tr className="table-row">
                        <td className="table-cell label">Nocturno diario</td>
                        <td className="table-cell max" id="consumoDiario"></td>
                        <td className="table-cell min" id="costeDiario"></td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">Nocturno mensual</td>
                        <td className="table-cell max" id="consumoMensual"></td>
                        <td className="table-cell min" id="costeMensual"></td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">Nocturno anual</td>
                        <td className="table-cell max" id="consumoAnual"></td>
                        <td className="table-cell min" id="costeAnual"></td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">
                          <div className="vertical">
                            <span>Capacidad necesaria de baterías</span>
                            <span className="size-xs"></span>
                          </div>
                        </td>
                        <td className="table-cell value" id="capacidadAlmacenaje" colSpan={"2"}></td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">Ahorro en electricidad</td>
                        <td className="table-cell value fill" colSpan={"2"}>
                          <div className="vertical">
                            <span id="ahorro"></span>                        
                          </div>
                        </td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">
                          <div className="vertical">
                            <span>Presupuesto final</span>
                            <span className="size-xs"></span>
                          </div>
                        </td>
                        <td className="table-cell value" id="presupuesto" colSpan={"2"}></td>
                      </tr>

                      <tr className="table-row">
                        <td className="table-cell label">Amortización</td>
                        <td className="table-cell value fill" colSpan={"2"}>
                          <div className="vertical">
                            <span id="amortizacion"></span>                        
                          </div>
                        </td>
                      </tr>

                    </tbody>
                  </table>
              </details>

            </div>

            { initialConfigCommonJS.existeSesion() ?
              <ul className="actions" style={{paddingTop: "20px"}}>         
                <button id="botonContactoInstalador" className="button primary full-width" onClick={() => advisoryCommonJS.mostrarInstaladoresCercanos("instalacion paneles solares",setObjListadoInstaladores)}>Ponme en contacto con un instalador ahora mismo</button>       
              </ul>
            :
              <></>
            }
            

          </div>

          <div id="localizadorInstaladores" className=" hidden">

            <button className="link back" onClick={() => volverAResultados()}><span className="material-icon">arrow_back</span>Volver</button>

            <ul className="providers-list vertical gap-06">

            <InstalersList objListadoInstaladores={objListadoInstaladores}/>

            </ul>

          </div>

        </section>

      </div>

    </main>
  )
}

export default BatteriesInstallation